import { Text } from "../../../../core/Text.js";
import type { BoxesTitleContent } from "../../boxesContent.js";

/** The page's one h1. */
export function BoxesTitle({ text }: BoxesTitleContent) {
  return (
    <Text as="h1" variant="display-xl2" tone="primary" className="max-md:text-display-xl3">
      {text}
    </Text>
  );
}
